import type { ReactNode } from "react";

import CareSuperLogo from "@/components/CareSuperLogo";
import Stepper from "@/components/Stepper";

// Shared two-column layout for the CareSuper join journey: the stepper
// (+ wordmark) on the left, the content card on the right. Used by signup-id,
// the email-OTP screen, and signup-password (whose internal wizard sub-steps
// just pass a different currentStep without actually changing screen).
//
// Step count varies by flow — 5 for Flow A, 4 for Flow B — so callers pass
// `steps` from journeySteps(detectFlow(...)). Omitting it falls back to Flow
// A's labels. See ARCHITECTURE.md "Signup Flows (A / B / C)".
interface JourneyLayoutProps {
  currentStep: number;
  steps?: readonly string[];
  children: ReactNode;
}

function JourneyLayout({ currentStep, steps, children }: JourneyLayoutProps) {
  return (
    <div className="min-h-screen w-full bg-white flex justify-center px-6 py-12 md:px-10">
      <div className="flex w-full max-w-4xl gap-12">
        <div className="hidden md:flex flex-col w-56 shrink-0">
          <CareSuperLogo className="h-10 w-auto mb-10" />
          <Stepper currentStep={currentStep} steps={steps} />
        </div>
        <div className="flex-1 flex flex-col md:hidden mb-6">
          <CareSuperLogo className="h-9 w-auto" />
        </div>
        <div className="flex-1 max-w-[480px]">{children}</div>
      </div>
    </div>
  );
}

export default JourneyLayout;
